import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shortDateTime' })
export class ShortDateTime extends DatePipe implements PipeTransform {
    override transform(value: any, args?: any): any {
        if (value == null || value == undefined || value == '/Date(-62135596800000)/') {
            return '';
            // this signifies undefined value passed in!
        } else {
            let s: string = value.toString().replace('/Date(', '').replace('/date(', '').replace(')/', '');
            return super.transform(s, 'MM/dd/yyyy');
        }
    }
}
